module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("\n        О продукте\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-container text-container__about valign"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaMore
    }
  }, [_c('span', [_vm._v("узнать больше")])]), _c('Arrow')], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "decoration-container decoration-container__about"
  }, [_c('div', {
    staticClass: "layer layer__1",
    style: ({
      transform: 'rotate(' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-7-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-6-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-5-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-2-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-3-2.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-1.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/item-4.png",
      "alt": "Item"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/grill2.png",
      "alt": "Item"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer__2",
    style: ({
      transform: 'rotate(-' + _vm.angle + 'deg)'
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade-left-top",
      "appear": ""
    }
  }, [_c('Item1')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-left-bottom",
      "appear": ""
    }
  }, [_c('Item2')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-top",
      "appear": ""
    }
  }, [_c('Item3')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-right-bottom",
      "appear": ""
    }
  }, [_c('Item4')], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Продолжаем сезон барбекю!"), _c('br'), _vm._v("И проводим его с максимальной пользой для кишечника.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_c('span', [_vm._v("БАКТИСТАТИН ®")]), _vm._v(" — комплекс дополняющих друг друга 3-х природных компонентов**:\n            "), _c('ul', [_c('li', [_vm._v("Метаболиты Bacillus subtilis (способствуют полноценному пищеварению)")]), _vm._v(" "), _c('li', [_vm._v("Природный сорбент цеолит (уменьшает различные виды интоксикации, нормализует перистальтику кишечника)")]), _vm._v(" "), _c('li', [_vm._v("Пребиотический компонент (обеспечивает благоприятные условия для роста и восстановления нормальной микрофлоры кишечника)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', [_vm._v("Открываете сезон барбекю — не забудьте про БАКТИСТАТИН®!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-right"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9e83dd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/About.vue
// module id = 109
// module chunks = 0